export enum ApplicationStatus {
  Closed = 'Closed',
  Declined = 'Declined',
  Incomplete = 'Incomplete',
  PendingReview = 'Pending Review',
  InReview = 'In Review',
  Offer = 'Offer',
  None = '',
}
